import { render, staticRenderFns } from "./drawerHeader.vue?vue&type=template&id=26d7779c&scoped=true&"
import script from "./drawerHeader.vue?vue&type=script&lang=js&"
export * from "./drawerHeader.vue?vue&type=script&lang=js&"
import style0 from "./drawerHeader.vue?vue&type=style&index=0&id=26d7779c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d7779c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
